import AppLogo from '@/components/appLogo';
import { Card } from '@/components/ui/card';
import { AuthContext } from '@/context/authContext';
import { useToast } from '@/hooks/useToast';
import { routes } from '@/types/routes';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (context.auth.tokens) {
      redirect({
        to: routes.patients,
        replace: true,
        throw: true,
      });
    }
  },
});

function RouteComponent() {
  const { loginSessionExpired, setLoginSessionExpired } = useContext(AuthContext);
  const { toast } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (!loginSessionExpired) return;

    setLoginSessionExpired(false);
    toast({
      variant: 'destructive',
      title: t('toasts.errors.sessionExpired.title'),
      description: t('toasts.errors.sessionExpired.description'),
    });
  }, [ loginSessionExpired ]);

  return (
    <div className="flex flex-col min-h-screen justify-start items-center bg-fill-surface-strong">
      <div className="flex flex-col items-start">
        <div className="py-space-3xl">
          <AppLogo />
        </div>

        <Card className="w-[400px]">
          <Outlet />
        </Card>
      </div>
    </div>
  );
}
